
import withRouterParams from '../withRouterParams';
import Page from './Page';
import request from '../request';
import swal from 'sweetalert';
import { hideLoading, showLoading } from '../loading';
import { Button, Divider } from '@mui/material';
import quickbooks from '../quickbooks';

class _QuickbooksCallback extends Page {

   state = {
      error: null
   }

   sendUrl = async () => {

      try {

         showLoading('Connecting to Quickbooks');

         const url = window.location.href;
         await request.post('/api/finance/quickbooks/config', { url });
         swal('Success', 'Quickbooks connected', 'success');
         window.App.redirect('/dashboard');
      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }
   }

   connect = async () => {
      
      try {

         showLoading('Connecting to Quickbooks');
         await quickbooks.connect();

      } catch (err) {
         swal("Error", err.message, 'error');
      } finally {
         hideLoading();
      }
   }

   getError() {
      return this.props.searchParams.error;
   }

   componentDidMount() {
      super.componentDidMount();

      const error = this.getError();

      if (error) {
         this.setState({ error });
      } else {
         this.sendUrl();
      }
   }

   _render() {
      return <div className='page-height flex justify-center items-center'>
         <div className='max-w-[400px] w-full p-8 border-b-[1px] border-gray-300'>
            <div className='text-xl text-gray-500'>
            <h2 className='font-bold text-lg'>
               {this.state.error ? 'Quickbooks connection failed' : 'Connect to Quickbooks'}
            </h2>
            <Divider className='my-4' />
               {
                  this.state.error ?
                     <>
                        <div
                           className='border-l-[4px] border-red-500 p-2 mt-4 bg-red-100 text-sm text-red-500 font-bold truncate'
                           title={this.state.error}
                        >
                           {this.state.error}
                        </div>

                        <Button onClick={this.connect} variant='contained' className='mt-4 px-4 rounded-full' size='small'>
                           Retry
                        </Button>

                     </> :
                     <>
                        <p className='text-sm'>
                           Click the button below to connect to finish connecting to Quickbooks.
                        </p>
                        <Button onClick={this.sendUrl} variant='contained' className='mt-4 px-4 rounded-full' size='small'>
                           Connect
                        </Button>
                     </>
               }
            </div>
         </div>
      </div>
   }
}

const QuickbooksCallback = withRouterParams(_QuickbooksCallback);

export default QuickbooksCallback;